<div class="container">
	<ngx-slick-carousel
		class="carousel"
		#slickModal="slick-carousel"
		(afterChange)="onAfterChange($event)"
		[config]="slideConfig"
	>
		<div ngxSlickItem class="slide" *ngFor="let item of data">
			<app-card
				[dataDictionary]="dataDictionary"
				[isPurifierCard]="true"
				[isCarouselCard]="false"
				[btnType]="'responsive'"
				[item]="item.product"
				[isIceCarousel]="true"
				[lang]="lang"
			></app-card>
		</div>
	</ngx-slick-carousel>
</div>
<div class="slick-progress-bar-container">
	<div class="slick-progress-bar" [style.width.%]="progressBarValue"></div>
</div>
